<template>
  <div class="download-brochure-page">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="landing-page-wrapper download-brochure-hero" style="overflow: visible;">
        <div class="landing-page-content">
          <div class="landing-page-section">
            <div class="landing-page-hero">
              <div class="landing-page-title" v-if="!pageEditMode">
                {{ content.heroSection.title }}
              </div>
              <textarea class="landing-page-title"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.title"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
              <div class="landing-page-description" v-if="!pageEditMode">
                {{ content.heroSection.description }}
              </div>
              <textarea class="landing-page-description"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.description"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
            </div>
            <div class="landing-page-download-request">
              <div class="input-group">
                <input type="email"
                       v-model="brochureRequest.email"
                       v-validate="'required|email'"
                       name="Email"
                       placeholder="Write your email address..." />
                <button
                        :class="[{ 'disabled': this.errors.has('Email') }]"
                        @click.prevent="requestBrochure()">Get brochure</button>
              </div>
              <div class="download-subscribe">
                <input type="checkbox"
                       id="subscribe"
                       v-model="brochureRequest.subscribe" />
                <label for="subscribe">Subscribe me to the newsletter</label>
              </div>
              <div class="download-subscribe-info" v-if="brochureRequest.subscribe">
                <strong>Privacy:</strong> Your details will be used to keep you informed about resources provided by The Clear Company.
                <router-link :to="{ name: 'privacy-policy' }">Click here</router-link> to find out more about the services we provide.
              </div>
              <div class="request-status"
                   :class="brochureRequest.success ? 'success' : 'error' "
                   v-if="brochureRequest.shown">
                {{ brochureRequest.message }}
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper download-brochure-summary">
        <div class="landing-page-content">
          <div class="landing-page-section">
            <div class="landing-page-summary">
              <div class="landing-page-summary__title" v-if="!pageEditMode">
                {{ content.contentSection.title }}
              </div>
              <textarea class="landing-page-summary__title"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.contentSection.title"
                        v-on:keydown="autoSize($event)">{{ content.contentSection.title }}</textarea>
              <ul class="landing-page-summary__items">
                <li class="landing-page-summary__item"
                     v-for="(item, index) in content.contentSection.summary">
                  <span class="landing-page-summary__item" v-if="!pageEditMode">{{ item.text }}</span>
                  <textarea class="landing-page-summary__item"
                            v-if="pageEditMode && isGM()"
                            data-gramm_editor="false"
                            placeholder="Summary item"
                            data-lpignore="true"
                            rows="1"
                            v-model="item.text"
                            v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
                  <div class="landing-page-remove"
                       v-if="pageEditMode && isGM()"
                       @click.prevent="removeSection(content.contentSection.summary, index)"></div>
                </li>
              </ul>
              <div class="landing-page-add-section"
                   @click.prevent="addSection(content.contentSection.summary)"
                   v-if="pageEditMode && isGM()">+ Add item</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h1>Change page meta</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'download-brochure',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: ''
        },
        contentSection: {
          title: '',
          summary: [
            {
              text: ''
            }
          ]
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: ''
        },
        contentSection: {
          title: '',
          summary: [
            {
              text: ''
            }
          ]
        }
      },
      brochureRequest: {
        shown: false,
        success: true,
        subscribe: false,
        message: '',
        email: ''
      },
      windowWidth: window.innerWidth
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole',
      'selectedHightCont',
      'getSelectedFontSize'
    ])
  },
  methods: {
    ...mapActions([
      'redirect',
      'getRoles',
      'setFontSizeActive',
      'setColorPaletteActive'
    ]),
    requestBrochure () {
      if (this.disableAPI) return
      let body = {
        email: this.brochureRequest.email,
        subscribe: this.brochureRequest.subscribe
      }
      this.disableAPI = true
      this.$http.post(api.URLS.brochureRequest, body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.brochureRequest.shown = true
        this.brochureRequest.success = true
        this.brochureRequest.subscribe = false
        this.brochureRequest.message = 'Please check your email. We sent you a download link.'
        this.brochureRequest.email = ''
      }).catch((err) => {
        this.disableAPI = false
        this.brochureRequest.shown = true
        this.brochureRequest.success = false
        this.brochureRequest.message = 'Server error'
        console.log('err', err)
      })
    },
    updateLandingPage () {
      if (this.disableAPI) return
      let body = JSON.stringify(this.content)
      let pageData = {
        slug: 'download-brochure-page',
        body: body
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.getLandingPage()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let metaTitle = this.metaData.title
      let metaDescription = this.metaData.description
      let pageData = {
        title: metaTitle,
        slug: 'download-brochure-page',
        description: metaDescription
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getLandingPage (id) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'download-brochure-page'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/download-brochure-page', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        this.content = pageData
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title + ' | Clear Assured'
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.content.title = this.metaData.title
        this.content.description = this.metaData.description
        if (id) {
          this.pageEditSwitch()
        } else {
          this.pageEditMode = false
        }
        this.$store.commit('setUserDimensions')
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['trackPageView'])
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/download-brochure-page', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage()
    },
    pageEditSwitch () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    closePopup () {
      this.pageMetaEdit = false
    },
    addSection (section) {
      section.push({
        text: ''
      })
    },
    removeSection (section, index) {
      section.splice(index, 1)
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      if (userRole === 'gm') {
        return true
      }
      return false
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width > 940) {
        deviceName = 'desktop'
      } else if (width > 640) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    }
  },
  created () {
    this.getLandingPage()
  },
  mounted () {
    this.setFontSizeActive()
    this.setColorPaletteActive()
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  watch: {}
}
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// DownloadBrochure.vue?60c4d81a